<template>
  <div class="status-page">
    <div :class="['status-toggle-card', website_status === 1 ? 'status-toggle-card--active' : '']">
      <div :class="['status-pulse', website_status === 1 ? 'status-pulse--active' : 'status-pulse--inactive']">
        <div :class="['status-icon', website_status === 1 ? 'status-icon--active' : 'status-icon--inactive']">
          <i :class="`pi ${website_status === 1 ? 'pi-check-circle' : 'pi-times-circle'}`"></i>
        </div>
      </div>
      <h2 class="status-title">حالة الحجز</h2>
      <p :class="['status-label', website_status === 1 ? 'status-label--active' : 'status-label--inactive']">
        <i class="pi pi-circle-fill" style="font-size:0.4rem;"></i>
        {{ website_status === 1 ? 'الحجز نشط' : 'الحجز غير نشط' }}
      </p>
      <p class="status-description">
        {{ website_status === 1
          ? 'الحجز متاح ويقبل طلبات التسجيل الجديدة حالياً.'
          : 'الحجز مغلق حالياً ولا يقبل طلبات تسجيل جديدة.' }}
      </p>
      <button
        type="button"
        :class="['status-action-btn', website_status === 1 ? 'status-action-btn--deactivate' : 'status-action-btn--activate']"
        @click="changeWebStatus"
      >
        <i :class="`pi ${website_status === 1 ? 'pi-pause-circle' : 'pi-play-circle'}`"></i>
        {{ website_status === 1 ? 'إيقاف الحجز' : 'تشغيل الحجز' }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
export default {
  name: "home-page",
  data() {
    return {
      website_status: 0 // 0: inactive, 1: active
    };
  },
  methods: {
    changeWebStatus() {
      const formData = new FormData();
      formData.append('website_status', this.website_status == 1 ? 0 : 1); // Toggle status

      axios
        .post('/set_website_status', formData)
        .then((response) => {
          if (response.data.status == true) {
            this.website_status = response.data.website_status == 1 ? 1 : 0; // Update local status
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم تحديث حالة الحجز بنجاح",
            });
          }
          else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "حدث خطأ أثناء تحديث حالة الحجز",
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
          });
        });
    },
    fetchWebStatus() {
      axios
        .get('/get_website_status')
        .then((response) => {
          this.website_status = response.data.website_status;
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
          });
        });
    }
  },
  mounted() {
    this.fetchWebStatus();
  }
}
</script>